import { useEffect, useMemo } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import UniversalRecordTable from '../../components/Tables/universalRecord/UniversalRecordTable';
import { useQzTrayConfiguration } from '../../hooks/qztray/useQzTrayConfiguration';
import { qzTrayConfigurationColumns } from '../../constants/qztray/qzTrayConfigurationColumns';
import QzTrayConfigurationAddModal from '../../components/qztray/configuration/QzTrayConfigurationAddModal';
import QzTrayConfigurationEditModal from '../../components/qztray/configuration/QzTrayConfigurationEditModal';
import { QzTrayConfiguration } from '../../types/qztray/QzTrayConfigurationTypes';
import QzTrayTestConnectionModal from '../../components/qztray/configuration/QzTrayTestConnectionModal';

/**
 * ⚙️ Página: Configuración Avanzada QZ Tray
 */
const QzTrayConfigurationPage = () => {
  const {
    configurations,
    isLoading,
    isSubmitting,
    createModalOpen,
    editModalOpen,
    fetchConfigurations,
    saveOrUpdateConfiguration,
    openCreateModal,
    closeCreateModal,
    closeEditModal,
    fetchActiveConfiguration,
    testConnection,
    testModalOpen,
    closeTestModal,
  } = useQzTrayConfiguration();

  const columns = useMemo(() => qzTrayConfigurationColumns, []);

  useEffect(() => {
    fetchConfigurations();
  }, []);

const getActions = (row: QzTrayConfiguration) => [
  {
    key: 'edit',
    label: 'Editar',
    onClick: () => fetchActiveConfiguration(row.tenantId),
  },
  {
    key: 'test',
    label: 'Probar conexión',
    onClick: () => testConnection(row),
  },
];


  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      {/* 🧾 Tabla principal */}
      <UniversalRecordTable
        columns={columns}
        data={configurations}
        getActions={getActions}
        showPagination={false}
        enableRowClick={true}
        noDataMessage="No hay configuraciones de QZ Tray registradas."
        isLoading={isLoading}
        topRightAction={{
          label: 'Nueva Configuración',
          onClick: openCreateModal,
        }}
      />

      {/* 🆕 Modal: Crear configuración */}
      <QzTrayConfigurationAddModal
        isOpen={createModalOpen}
        onClose={closeCreateModal}
        onSubmit={saveOrUpdateConfiguration}
        isSubmitting={isSubmitting}
      />

      {/* ✏️ Modal: Editar configuración */}
      <QzTrayConfigurationEditModal
        isOpen={editModalOpen}
        onClose={closeEditModal}
        onSubmit={saveOrUpdateConfiguration}
        isSubmitting={isSubmitting}
      />

      <QzTrayTestConnectionModal
        isOpen={testModalOpen}
        onClose={closeTestModal}
      />
    </DefaultLayout>
  );
};

export default QzTrayConfigurationPage;
